import { Route, Routes } from "react-router-dom";

import ContractorListScreen from "screens/App/CRM/Contractor/ContractorListScreen";
import ContractorInfoScreen from "screens/App/CRM/Contractor/ContractorInfoScreen";
import ContractorDetailScreen from "screens/App/CRM/Contractor/ContractorDetailScreen";
import ContractorEditScreen from "screens/App/CRM/Contractor/ContractorEditScreen";
import ContractorCreateScreen from "screens/App/CRM/Contractor/ContractorCreateScreen";
import DriverCreateScreen from "screens/App/CRM/Driver/DriverCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const ContractorRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<ContractorListScreen />} />

      <Route path="create" element={<ContractorCreateScreen />} />

      <Route path="contractor/driver" element={<DriverCreateScreen />} />

      <Route path=":id/detail" element={<ContractorDetailScreen />} />

      <Route path=":id/edit" element={<ContractorEditScreen />} />

      <Route path="info" element={<ContractorInfoScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default ContractorRouter;
